/**
 * @generated SignedSource<<3443adcefe49343fb213308717dd828f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NetworkOwner",
    "kind": "LinkedField",
    "name": "allNetworkOwners",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NetworkOwnersQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NetworkOwnersQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e4d0e75c9714ee661809a7dd3da833fa",
    "id": null,
    "metadata": {},
    "name": "NetworkOwnersQuery",
    "operationKind": "query",
    "text": "query NetworkOwnersQuery {\n  allNetworkOwners {\n    id\n    name\n  }\n}\n"
  }
};
})();

node.hash = "4f884bb20545a109e46a0025e8a3e8eb";

export default node;
